/**
 * 历史记录类型
 */
export enum HistoryType {
    SEEK_SEARCH = 'SEEK_SEARCH',
    TECH_MIND = 'TECH_MIND',
    MATERIAL_MIND = 'MATERIAL_MIND',
    TECH_RESEARCH = 'TECH_RESEARCH',
    TECH_FMEA = 'TECH_FMEA',
    /**
     * 旧的白板历史记录类型
     */
    IDEA_EXPLORATION = 'IDEA_EXPLORATION',
    PATENT_DISCLOSURE = 'PATENT_DISCLOSURE'
}

/**
 * 菜单类型
 */
export enum MenuPath {
    /**
     * 首页
     */
    HOME = 'home',
    SEEK = 'seek',
    WORKSPACE = 'workspace',
    HISTORY = 'history',
    MONITOR = 'monitor',
    /**
     * MONITOR 所有订阅列表
     */
    MONITOR_TOPIC = 'topics',
    /**
     * MONITOR 我的监控列表
     */
    MONITOR_SUBSCRIPTION = 'my',
    INCOGNITO = 'incognito',
    MATERIAL_MIND = 'whiteboard/material'
}
export interface HistoryItem {
    id: string;
    message: string
    source: HistoryType,
    created_at: string,
    active?: boolean,
    link?: string,
    business_id?: string,
}

type RowType = 'search' | 'view' | 'all' | 'playbook'

export interface HistoryRowData {
    rawType: RowType,
    /**
     * 跳转参数链接
     */
    link: string,
    /**
     * 专利详情标题（查看详情记录才有）
     */
    message: string,
    /**
     * 专利详情跳转ID（查看详情记录才有）
     */
    patentId: string,
    /**
     * 搜索数量
     */
    count: {
        number: number
    },
    source: HistoryType,
    q_s: any
    /**
     * 搜索语句
     */
    q: string,
    /**
     * 搜索过滤项参数
     */
    efq: any,
    /**
     * 历史记录ID
     */
    id: string,
    /**
     * 历史记录时间
     */
    time: string
}

export interface HistoryDateRowData {
    date: string,
    data: HistoryRowData[]
}
export interface GetNavListResponse {
    limit: number,
    page: number,
    history_maps: HistoryDateRowData[],
}

export enum NavTheme {
    DARK = 'dark',
    LIGHT = 'light'
}

export enum NavSection {
    DEFAULT = 'DEFAULT',
    HEADER = 'HEADER',
    FOOTER = 'FOOTER'
}

export interface NavMenuItem {
    id: string;
    title: string;
    icon?: string;
    children?: NavMenuItem[];
    active?: boolean;
    expand?: boolean;
    onClick?: () => void;
}
